angular.module('impactx.search').directive('initBind', function($compile, $parse) {
    return {
        restrict: 'A',
        link : function (scope, element, attr) {
            var parsed = $parse(attr.ngBindHtml);
            function getStringValue() { return (parsed(scope) || '').toString(); }

            //Recompile if the template changes
            var watcher = scope.$watch(getStringValue, function() {
                $compile(element, null, -9999)(scope);
                watcher();
            });
        }
    };
});